<header class="profile-header">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <app-navbar></app-navbar>
      </div>
      <div class="col-12">
        <div class="row header-content">
          <div class="col-xl-12 col-sm-12 p-md-0">
            <div class="subscribe-container row">
              <div class="col-sm-12 col-md-6">
                <h1 class="hidaya-heading">{{ "HIDAYA_HAEDING" | translate }}</h1>
                <h3 class="hidaya-text">{{ "HIDAYA_TEXT" | translate }}</h3>
              </div>
              <div class="form-container col-12 d-flex flex-column " style="position: relative;">
                <h2 class="operator-head">
                  {{(phoneNumber.startsWith('21893') || phoneNumber.startsWith('21891') ? "ELMADAR" : "LIBYANA") |
                  translate}}
                </h2>
                <div class="d-flex mb-3">
                  <img class="subscribed-image ms-2" src="../../../assets/images/subscribed.svg">
                  <span class="subscripe-text m-0">
                    {{ "ALREADY_SUBSCRIPED" | translate }} {{ subscription_name }}
                  </span>
                </div>
                <div class="button-container">
                  <button type="button" [disabled]="isSubmitting" class="btn btn-primary mt-2 submit_btn"
                    (click)="onLogout()">
                    {{ "LOGOUT" | translate }}
                  </button>
                  <a class="cancel-btn" (click)="onUnsubscribe()" style="cursor: pointer;">{{ "CANCEL" | translate
                    }}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


  </div>
  <p-dialog class="dialog" [(visible)]="isUnsubscribeConfirm" [modal]="true" (onHide)="hideOtpPopup()"
    [style]="{width: '642px', 'border-radius': '12px', overflow: 'hidden'}" [baseZIndex]="10000">
    <ng-template pTemplate="content">
    </ng-template>

    <div *ngIf="successOTP" class="alert alert-success mb-2 col-12 text-center">{{ successOTP }}</div>
    <div *ngIf="errorOTP" class="mb-2 col-12 text-center alert alert-danger">{{ errorOTP }}</div>

    <form (ngSubmit)="onUnsubscribeConfirm()" #authForm="ngForm">
      <div class="dialog-msg-container">
        <span class="otp-dialog-label">{{ "OTP_DIALOG_LABEL" | translate }}</span>
        <span class="otp-dialog-msg">
          {{ "OTP_DIALOG_MSG1" | translate }} <br>
          {{ phoneMask || "XXXXXXX90" }}
        </span>
        <span class="otp-dialog-msg">{{ "OTP_DIALOG_MSG2_UNSUBSCRIPE" | translate }}
          {{(phoneNumber.startsWith('21893') ||
          phoneNumber.startsWith('21891') ? "OTP_DIALOG_MSG2_ELMADAR_PACKAGE" :
          "OTP_DIALOG_MSG2_LIBYANA_PACKAGE") |
          translate}}
        </span>
      </div>

      <div class="otp-form-container">
        <div class="form-group otp-fg">
          <p-inputOtp [(ngModel)]="otpValue" (ngModelChange)="onOtpChange($event)" name="otpValue" [dir]="'ltr'"
            *ngIf="otpVisible">
            <ng-template pTemplate="input" let-token let-events="events">
              <input class="p-inputtext p-component p-element p-inputotp-input" (input)="events.input($event)"
                (keydown)="events.keydown($event)" type="number" [value]="token" [maxLength]="1" inputmode="numeric" />
            </ng-template>
          </p-inputOtp>
        </div>
        <button type="submit" [disabled]="isSubmitting" class="btn btn-primary mt-2 submit_btn">{{ isSubmitting ?
          ("LOADING" | translate) : ("SUBMIT" | translate) }}</button>

        <div class="d-flex flex-column align-items-center justify-content-center mb-4">
          <span class="count-down number-text">{{ countdownDisplay }}</span>
          <span class="resend-text">{{ "DIDNOT_RECIEVE_OTP" | translate }}</span>
          <a class="resend-action" style="cursor: pointer;" [class.disabled]="countdownDisplay !== '00:00'"
            (click)="countdownDisplay === '00:00' && onUnsubscribe()">{{ "RESEND_OTP" | translate }}</a>
        </div>
      </div>

    </form>
  </p-dialog>

  <p-confirmDialog #cd key="confirm">
    <ng-template pTemplate="message" let-message>
      <div class="d-flex flex-column align-items-center justify-content-center p-5 surface-overlay border-round mb-2"
        style="overflow-y: hidden;">
        <img class="dialog-icon" src="../../../assets/images/checkbox-circle-fill.svg">
        <span id="dialog-content" class="justify-content-center">
          {{ message.message }}
        </span>
      </div>
    </ng-template>
  </p-confirmDialog>
</header>